const parseFilters = (filters) => {
  for (const [key, value] of Object.entries(filters)) {
    if (Array.isArray(value)) {
      filters[key] = value.join(','); // e.g. status=1,2,3,4
    }
  }
  return filters;
}

export { parseFilters };